import { cn } from "@/lib/utils";

export default function VoiceVisualizer({ isActive }) {
  // Colors matching the landing page - cyan when active, gray when inactive
  const bars = [
    { className: "voice-bar-1", delay: "0ms" },
    { className: "voice-bar-2", delay: "100ms" },
    { className: "voice-bar-3", delay: "200ms" },
    { className: "voice-bar-4", delay: "150ms" },
    { className: "voice-bar-5", delay: "50ms" },
    { className: "voice-bar-4", delay: "180ms" },
    { className: "voice-bar-3", delay: "120ms" },
    { className: "voice-bar-2", delay: "80ms" },
    { className: "voice-bar-1", delay: "160ms" },
    { className: "voice-bar-3", delay: "90ms" },
  ];

  return (
    <div
      className="h-10 flex items-center justify-center gap-0.5 px-4 py-2 rounded-full transition-all duration-300"
      style={{
        backgroundColor: isActive ? 'rgba(34, 211, 238, 0.1)' : 'rgba(45, 55, 72, 0.5)',
        border: isActive ? '1px solid rgba(34, 211, 238, 0.3)' : '1px solid rgba(45, 55, 72, 0.5)'
      }}
      data-testid="voice-visualizer"
    >
      {bars.map((bar, index) => (
        <div
          key={index}
          className={cn(
            "w-1 rounded-full transition-all duration-300",
            isActive && bar.className
          )}
          style={{
            backgroundColor: isActive ? '#22d3ee' : '#374151',
            height: isActive ? undefined : '10px',
            animationDelay: isActive ? bar.delay : undefined,
          }}
        />
      ))}
    </div>
  );
}
